import type { DownstreamFailureReason } from '@core/ports/DownstreamFailureReason';

export const retryOutcomeHeaders = {
  outcome: 'X-Inav-Retry-Outcome',
  failureReason: 'X-Inav-Failure-Reason',
  failureType: 'X-Inav-Failure-Type'
} as const;

const downstreamFailureReasons: readonly DownstreamFailureReason[] = ['timeout', 'throttled', 'unavailable', 'terminal', 'unknown'];
const downstreamFailureReasonSet = new Set<DownstreamFailureReason>(downstreamFailureReasons);

export function getDownstreamFailureReason(headers: Headers): DownstreamFailureReason | undefined {
  const failureReason = headers.get(retryOutcomeHeaders.failureReason);

  return failureReason && downstreamFailureReasonSet.has(failureReason as DownstreamFailureReason)
    ? failureReason as DownstreamFailureReason
    : undefined;
}

export function getTransientRetryStopFailureReason(headers: Headers): DownstreamFailureReason | undefined {
  return hasTransientRetryStop(headers)
    ? getDownstreamFailureReason(headers)
    : undefined;
}

export function hasCommitAmbiguousStop(headers: Headers): boolean {
  return headers.get(retryOutcomeHeaders.outcome) === 'commit-ambiguous-stop'
    && headers.get(retryOutcomeHeaders.failureType) === 'transient';
}

export function hasTransientRetryStop(headers: Headers): boolean {
  return headers.get(retryOutcomeHeaders.outcome) === 'stop'
    && headers.get(retryOutcomeHeaders.failureType) === 'transient';
}